var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('Navigation',{attrs:{"account-id":_vm.accountId,"page-size":_vm.pageSize,"template-id":_vm.templateId,"include-past":_vm.includePast,"only-past":_vm.onlyPast}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }